import React from 'react';
import type { UnsupportedRequest } from '../../types/messages';
import MessageActionCard from './MessageActionCard';

type Props = {
  unsupportedRequest: UnsupportedRequest;
};

const UnsupportedRequestMessage = ({ unsupportedRequest }: Props) => (
  <MessageActionCard
    title={unsupportedRequest.title}
    items={unsupportedRequest.supportedProducts}
    description={unsupportedRequest.description}
    actionHref={unsupportedRequest.dashboardPath}
    actionLabel={unsupportedRequest.dashboardLabel}
  />
);

export default UnsupportedRequestMessage;
